<template>
  <el-popover
    :offset="10"
    width="240"
    v-model="show"
    :placement="placement"
    :disabled="disabled"
    :trigger="modalTrigger"
  >
    <div class="popover">
      <div class="modal-container">
        <div class="list-container">
          <div v-for="typeList in list" :key="typeList.title" class="type-list">
            <div class="type-container">
              {{ typeList.title }}
            </div>
            <div
              class="list-item"
              @click="itemClick(item)"
              :class="{ invalid: item.invalid }"
              :key="item.publisherId"
              v-for="item in typeList.items"
            >
              <div
                class="image"
                :key="item.image"
                v-lazy:background-image="item.image"
              >
                <div
                  v-if="item.socialNetwork === 1"
                  class="ins-user-icon"
                ></div>
                <div
                  v-if="item.socialNetwork === 2"
                  class="fb-page-user-icon"
                ></div>
                <div
                  v-if="item.socialNetwork === 3"
                  class="fb-group-user-icon"
                ></div>
                <div v-if="item.socialNetwork === 4" class="tw-user-icon"></div>
              </div>
              <div class="right-container">
                <div class="username-text">{{ item.username }}</div>
                <div class="des-text">{{ item.description }}</div>
              </div>
              <div v-if="type === 'mul'" class="icon-container">
                <div
                  :class="{ selected: item.select }"
                  class="select-icon"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-bottom-container" v-if="filter === 'callback'">
          <div class="modal-btn" @click="show = false">Cancel</div>
          <div class="modal-btn" @click="callbackConfirmClick">Done</div>
        </div>
      </div>
      <el-popover
        placement="right-end"
        width="230"
        v-model="platformModal"
        trigger="hover"
      >
        <div class="platform-list-container">
          <div class="platform-item" @click="addInsBtnClick">
            <div class="icon ins"></div>
            <div class="text">Instagram</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addFbPageBtnClick">
            <div class="icon fb"></div>
            <div class="text">Facebook Page</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addFbGroupBtnClick">
            <div class="icon fb-group"></div>
            <div class="text">Facebook Group</div>
            <div class="right-icon"></div>
          </div>
          <div class="platform-item" @click="addTwitterBtnClick">
            <div class="icon twitter"></div>
            <div class="text">Twitter</div>
            <div class="right-icon"></div>
          </div>
        </div>
        <div slot="reference" v-if="type === 'single'" class="add-btn">
          <div class="add-icon"></div>
          Add Social Account
        </div>
      </el-popover>
    </div>
    <div slot="reference" @click="slotClick">
      <slot></slot>
    </div>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";
.platform-list-container {
  padding: 10px 0;
  .platform-item {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    .icon {
      height: 22px;
      width: 22px;
      background-size: contain;
      &.ins {
        background-image: url("../../../../public/images/common/list_ins@3x.png");
      }
      &.fb {
        background-image: url("../../../../public/images/common/list_fb@3x.png");
      }
      &.fb-group {
        background-image: url("../../../../public/images/common/list_fb_group@3x.png");
      }
      &.twitter {
        background-image: url("../../../../public/images/common/list_twitter@3x.png");
      }
    }
    .right-icon {
      height: 18px;
      width: 10px;
      background-size: contain;
      background-image: url("../../../../public/images/schedule_posts/Date_Right@3x.png");
    }
    .text {
      flex: 1;
      padding-left: 10px;
      font-size: 16px;
    }
  }
}
.popover {
  padding-bottom: 14px;
  .modal-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .modal-bottom-container {
      border-top: 1px solid #e5e5e5;
      padding-top: 14px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      padding: 14px 15px 0 15px;
      .modal-btn {
        color: #e62b55;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
  .list-container {
    max-height: 400px;
    overflow: auto;
    padding-bottom: 7px;

    .type-list {
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 7px;

      &:last-child {
        border-color: transparent;
      }
    }
  }

  .type-container {
    font-size: 16px;
    padding: 15px 15px 7px 15px;
    color: #000000;
    font-weight: 500;
  }

  .list-item {
    display: flex;
    padding: 0 15px;
    height: 50px;
    align-items: center;
    cursor: pointer;

    &.invalid {
      .icon-container .select-icon {
        background: rgba(163, 163, 163, 0.59);
        border-radius: 50%;
        width: 18px;
        height: 18px;
        position: relative;
        left: -1px;
      }
    }

    &:active,
    &:hover {
      background: #e5e5e5;
    }

    .image {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-position: center;
      background-size: contain;
      position: relative;
    }

    .right-container {
      padding-left: 10px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;

      .username-text {
        font-size: 16px;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: start;
        white-space: nowrap;
      }

      .des-text {
        font-size: 13px;
        color: @font-color-gray;
      }
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;

      .select-icon {
        background-image: url("../../../../public/images/common/Normal@3x.png");
        width: 35px;
        height: 35px;
        background-size: contain;

        &.selected {
          background-image: url("../../../../public/images/common/Select@3x.png");
        }
      }
    }
  }

  .add-btn {
    padding-top: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e72955;
    font-size: 16px;
    border-top: 1px solid #e6e6e6;
    cursor: pointer;
    font-weight: 500;

    .add-icon {
      background-image: url("../../../../public/images/common/add_ins.png");
      width: 18px;
      height: 18px;
      background-size: contain;
      margin-right: 10px;
      position: relative;
      bottom: 1px;
    }

    &:active,
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_SIMPLE,
} from "../../../store/mutation-types";
import { linkedInstagramTypes } from "../../../const/plan";

export default {
  name: "InsListPopoverComponent",
  model: {
    // 实现v-model
    prop: "val",
    event: "updateVal",
  },
  props: {
    showFacebook: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "single", // single:单选模式 mul:多选模式
    },
    selectIds: {
      type: Array,
      default: () => [], // 默认选中项
    },
    filter: {
      // 数据的过滤方式 all 不过滤 login 过滤掉需要登录的用户 callback:也是不过滤，不过数据不进行双向绑定
      type: String,
      default: "all",
    },
    val: {
      type: Boolean,
      default: false,
    },
    trigger: {
      type: String, // 弹出方式
      default: "click",
    },
    placement: {
      // 弹出组件的方向
      type: String,
      default: "bottom",
    },
    disabled: {
      // 是否禁用
      type: Boolean,
      default: false,
    },
    mulSocialNetworkFilter: {
      // 多选过滤当前选中用户network同类型
      type: Boolean,
      default: true,
    },
    medias: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      platformModal: false,
      show: this.val,
      showLoginDialog: false,
      currentSelectIds: [],
    };
  },
  watch: {
    /**
     * 监听文本值变化，变化时触发updateVal事件，实现双向绑定
     */
    show(val) {
      this.$emit("updateVal", this.show);
      // 每次打开组件的时候自动将选中信息进行填入
      if (val) {
        this.currentSelectIds = [...this.selectIds];
      }
    },
    /**
     * 当props val变化时改变data中value值，从而实现双向绑定
     */
    val(val) {
      this.show = val;
    },
  },
  methods: {
    slotClick() {
      if (this.filter === "callback") {
        this.show = true;
      }
    },
    /**
     * 添加点击事件
     */
    addInsBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddIns", {});
    },
    addFbPageBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookPage", { homeLogin: true });
    },
    addFbGroupBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddFacebookGroup", {});
    },
    addTwitterBtnClick() {
      this.show = false;
      this.platformModal = false;
      this.$bus.$emit("showAddTwitter", {});
    },
    callbackConfirmClick() {
      this.$emit("itemClick", this.currentSelectIds);
      this.show = false;
    },
    /**
     * 单条点击事件
     */
    async itemClick(item) {
      // 获取当前页面地址
      if (item.status === 0 || item.status === 2) {
        if (item.socialNetwork === 1) {
          // this.$bus.$emit('showAddIns', {
          //   username: item.username,
          //   insType: 'verify',
          //   message: 'Use Apphi APP on your phone to login.',
          //   autoSwitch: this.type === 'single'
          // })
          this.$bus.$emit("showAddIns", { publisherId: item.publisherId });
        } else if (item.socialNetwork === 2) {
          this.$bus.$emit("showAddFacebookPage", {
            publisherId: item.publisherId,
          });
        } else if (item.socialNetwork === 3) {
          this.$bus.$emit("showAddFacebookGroup", {
            publisherId: item.publisherId,
          });
        } else if (item.socialNetwork === 4) {
          this.$bus.$emit("showAddTwitter", { publisherId: item.publisherId });
        }
        this.show = false;
      } else {
        // 判断当前是否为 callback模式，如果是则判断当前选择的media是否符合tw规范
        if (
          item.socialNetwork === 4 &&
          this.filter === "callback" &&
          !this.canAddTwitter
        ) {
          await this.$alert.show({
            text: "Only supports 1 video or max 4 photos on Twitter.",
            yesText: "OK",
          });
          return;
        }
        // 单选模式
        if (this.type === "single") {
          this.show = false;
          this.$emit("itemClick", item);
        } else {
          // 查看以选中项中是否包含点击项
          const index = this.currentSelectIds.findIndex((id) => {
            return item.publisherId === id;
          });
          // 如果不存在，则添加当前点击项到数组中
          if (index === -1) {
            this.currentSelectIds.push(item.publisherId);
            if (this.filter !== "callback") {
              this.selectIds.push(item.publisherId);
            }
          } else {
            if (
              this.currentSelectIds.length !== 1 ||
              this.mulSocialNetworkFilter
            ) {
              // 否则删除该项
              this.currentSelectIds.splice(index, 1);
              if (this.filter !== "callback") {
                this.selectIds.splice(index, 1);
              }
            }
          }
          if (this.filter !== "callback") {
            this.$emit("itemClick", this.currentSelectIds);
          }
          if (this.selectIds.length === 0) {
            this.show = false;
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    modalTrigger() {
      // 这里比较特殊，如果非callback模式，则以用户输入为准
      if (this.filter === "callback") {
        return "manual";
      }
      return this.trigger;
    },
    // 计算所选图片是否为
    canAddTwitter() {
      const hasVideo = this.medias.find((i) => i.type === 2);
      if (hasVideo && this.medias.length > 1) {
        return false;
      }
      if (this.medias.length > 4) {
        return false;
      }
      return true;
    },
    publisher() {
      if (this.selectIds.length === 0) {
        return this.currentPublisher;
      }
      return this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.selectIds[0]
      );
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      this.user.linkedInstagramList.forEach((l) => {
        l.select =
          this.currentSelectIds.find((id) => id === l.publisherId) !==
          undefined;
        // 需要登录的用户计算无效ins
        if (this.filter === "login") {
          l.invalid = l.status === 0;
        } else {
          l.invalid = false;
        }
        // 如果callback模式，多媒体文件选择过多，造成tw无法使用，则显示灰色状态
        if (
          l.socialNetwork === 4 &&
          this.filter === "callback" &&
          !this.canAddTwitter
        ) {
          l.invalid = true;
        }
      });
      const list = this.user.linkedInstagramList.filter((l) => {
        // 过滤掉和当前选中用户不同的类型
        if (this.type === "mul" && this.mulSocialNetworkFilter) {
          let sameSocialNetwork =
            this.publisher.socialNetwork === l.socialNetwork;
          // 特殊情况 2，3被视为同一类型
          if (
            (this.publisher.socialNetwork === 2 ||
              this.publisher.socialNetwork === 3) &&
            (l.socialNetwork === 2 || l.socialNetwork === 3)
          ) {
            sameSocialNetwork = true;
          }
          if (!sameSocialNetwork) {
            return false;
          }
        }
        if (this.filter === "login") {
          return l.status !== 2;
        }
        return true;
      });
      // 根据类型进行分组
      let types = [];
      const limitedPublishers = list.filter(
        (l) => !l.isUnlimited && !l.isMember
      );
      const unlimitedPublishers = list.filter(
        (l) => l.isUnlimited && !l.isMember
      );
      const memberPublishers = list.filter((l) => l.isMember);
      if (unlimitedPublishers.length > 0) {
        types.push({
          title: linkedInstagramTypes[1].text,
          items: unlimitedPublishers,
        });
      }
      if (memberPublishers.length > 0) {
        types.push({
          title: linkedInstagramTypes[2].text,
          items: memberPublishers,
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          title: linkedInstagramTypes[0].text,
          items: limitedPublishers,
        });
      }
      return types;
    },
  },
};
</script>
